<mat-toolbar>
  <span class="navbar-brand">
    ProjectZen<sup [hidden]="!accountService.subscription().isProAccount">+</sup>
  </span>

  @if(isSmallScreen) {
    <button mat-mini-fab (click)="toggleMenu()" class="mat-menu-icon">
      <mat-icon>menu</mat-icon>
    </button>
  }

  <div [ngClass]="isSmallScreen ? 'toolbar-menu': 'toolbar-row'"
      [@toggleContainer]="isSmallScreen ?  isToggleMenu ? 'expand' : 'collapse' : ''">
    <mat-form-field class="search-input" (click)="handleSearchInputHelp()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
      <input type="text" matInput #filterInput placeholder="Search" name="Search"
        (keyup)="applyTextFilter(filterInput.value)" autocomplete="off">
        @if (filterInput.value) {
        <mat-icon matSuffix (click)="applyTextFilter(''); filterInput.value ='' ">close</mat-icon>
        }
    </mat-form-field>
  
    <div [ngClass]="isSmallScreen ? 'toolbar-menu-buttons' : 'toolbar-row'">
      <div class="toolbar-spacer">
        @for (option of buttonOptions; track $index)
        {
        <button mat-mini-fab [ngClass]="activeToggle() === option.type ? 'selected' : ''" class="list-view"
          (click)="toggleView(option.type)" [matTooltip]="option.tooltip">
          <mat-icon>{{option.icon}}</mat-icon>
        </button>
        }
      </div>
    
      <div class="toolbar-save">
        <button mat-flat-button class="toolbar-save-button" (click)="save()" [disabled]="navBarSaveButton().disabled">
          {{ navBarSaveButton().text }}
        </button>
    
        <button mat-mini-fab [matMenuTriggerFor]="menu" [matTooltip]='accountSettingTooltip' matTooltipClass="multiline-tooltip">
          <mat-icon aria-hidden="false" aria-label="Profile">person</mat-icon>
        </button>
        <mat-menu #menu="matMenu" class="mat-menu-items">
          <button mat-menu-item (click)="showAccountSettingsDialog()"><mat-icon>settings</mat-icon>Settings</button>
          <button mat-menu-item (click)="showWelcomeTutorial()"><mat-icon>help</mat-icon>Help</button>
          <button mat-menu-item (click)="logout()"><mat-icon>logout</mat-icon>Log Out</button>
        </mat-menu>
      </div>
    </div>
  </div>
</mat-toolbar>  

<ng-template cdkConnectedOverlay
[cdkConnectedOverlayOrigin]="trigger"
[cdkConnectedOverlayOpen]="showSearchInputHelp"
(detach)="showSearchInputHelp = false"
[cdkConnectedOverlayMinWidth]="'24.5%'"
>
  <div class="search-input-help">
    <span class="">Try "status: to do"</span> <span class="learn-more" (click)="showSearchOptions()">Learn More</span>
  </div>
</ng-template>